// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT!!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "b615f6c9",
    "hash": "b615f6c9",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "b615f6c9",
    "semverString": null,
    "version": "1.0.0"
};
/* tslint:enable */
